// ============================================
// CHECKOUT RULES
// ============================================
// What the checkout page needs before an order can be confirmed, in the order
// the fields appear on the page — so the first entry is where to scroll.
//
// The phone number is also the customer's payment reference (what they type
// in their bank app), so a typo there matters: it is checked, not just filled.

// Digits only, with a +60 / 60 country prefix turned into the local leading 0.
export const normalizeMyPhone = (input) => {
  const digits = String(input || '').replace(/\D/g, '');
  return digits.startsWith('60') ? `0${digits.slice(2)}` : digits;
};

// A Malaysian mobile number: 01x followed by 7–8 more digits (10–11 in total).
export const isValidMyMobile = (input) => /^01\d{8,9}$/.test(normalizeMyPhone(input));

export const missingCheckoutFields = ({ delivery, date, time, name, phone, receiptFile } = {}) => {
  const missing = [];
  if (!delivery) missing.push({ field: 'delivery', message: 'Please choose pickup or Grab Express' });
  if (!date) missing.push({ field: 'date', message: 'Please choose a date' });
  if (!time) missing.push({ field: 'time', message: 'Please choose a time' });
  if (!String(name || '').trim()) missing.push({ field: 'name', message: 'Please enter your name' });
  if (!String(phone || '').trim()) missing.push({ field: 'phone', message: 'Please enter your phone number' });
  else if (!isValidMyMobile(phone)) missing.push({ field: 'phone', message: 'Please check your phone number, e.g. 012-345 6789' });
  if (!receiptFile) missing.push({ field: 'receipt', message: 'Please upload your payment receipt' });
  return missing;
};
